<template>
  <div @click="action($event, params)" class="link has-text-weight-semibold">
    {{ text }}
  </div>
</template>
<script>

  export default {
    name: 'action-component',
    props: {
      text: {
        type: String,
        required: true
      },
      action: {
        type: Function,
        required: true
      },
      params: {
        type: Object,
        default: () => {}
      }
    }
  }
</script>
<style lang="sass" scoped>
  .link
    cursor: pointer
    color: #00C989
</style>
